export const FLAG_GETTING_DEPOSIT_MIGRATIONS =
  'FLAG_GETTING_DEPOSIT_MIGRATIONS';
export const GET_DEPOSIT_MIGRATIONS = 'GET_DEPOSIT_MIGRATIONS';
export const CLEAR_DEPOSIT_MIGRATIONS = 'CLEAR_DEPOSIT_MIGRATIONS';

export const FLAG_DEPOSIT_MIGRATION_ACTIVITY =
  'FLAG_DEPOSIT_MIGRATION_ACTIVITY';
export const GET_DEPOSIT_MIGRATION = 'GET_DEPOSIT_MIGRATION';
export const CLEAR_DEPOSIT_MIGRATION = 'CLEAR_DEPOSIT_MIGRATION';

export const FLAG_GETTING_DEPOSIT_MIGRATION_MOVEMENTS =
  'FLAG_GETTING_DEPOSIT_MIGRATION_MOVEMENTS';
export const GET_DEPOSIT_MIGRATION_MOVEMENTS =
  'GET_DEPOSIT_MIGRATION_MOVEMENTS';
export const CLEAR_DEPOSIT_MIGRATION_MOVEMENTS =
  'CLEAR_DEPOSIT_MIGRATION_MOVEMENTS';
